<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>Thanks to Austin Macauley Publishers for giving life to the pdf document and then making it possible for a book filled with energy to reach the millions of people in the whole world. Impacting their lives from thereon, for every word brings knowledge and insight into one’s soul; while filling the heart with desires to move higher in life. A book then becomes billions of stories worth telling. Thanks, Austin Macauley.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?b9a954ee